import ContactPage from './contact';
import BlogPage from './blog';

document.addEventListener('DOMContentLoaded', () => {
	const contactPage = new ContactPage();
	const blogPage = new BlogPage();
	const hamburger = document.querySelector('.hamburger');
	const closeMenu = document.querySelector('.close-menu');
	const nav = document.querySelector('.main-header nav');

	new fullpage('#fullpage', {
		scrollingSpeed: 1000,
		autoScrolling: true,
		scrollHorizontally: true,
		navigation: true,
		css3: false,
		licenseKey: 'BC43600D-52E74460-806626AA-02B6AE1C',
		afterRender: function (origin, _destination, direction) {
			const current = origin.item;

			if (current.querySelector('img')) {
				current.querySelector('img').classList.add('animate__animated', 'animate__fadeIn', 'animate__slow');
			}

			if (current.querySelector('h1')) {
				current.querySelector('h1').classList.add('animate__animated', 'animate__fadeInUp', 'animate__slow');
			}

			if (current.querySelector('.content')) {
				current.querySelector('.content').classList.add('animate__animated', 'animate__fadeInUp', 'animate__slow', 'animate__delay-1s');
			}
		},
		onLeave: function (_origin, destination, direction) {
			const current = destination.item;

			if (direction === 'down') {
				if (current.querySelector('img')) {
					current.querySelector('img').classList.add('animate__animated', 'animate__fadeIn', 'animate__slow');
				}

				if (current.querySelector('h1')) {
					current.querySelector('h1').classList.add('animate__animated', 'animate__fadeInUp', 'animate__slow');
				}

				if (current.querySelector('.content')) {
					current.querySelector('.content').classList.add('animate__animated', 'animate__fadeInUp', 'animate__slow', 'animate__delay-1s');
				}
			}
		}
	});

	hamburger.addEventListener('click', function () {
		nav.classList.add('open');
	});

	closeMenu.addEventListener('click', function () {
		nav.classList.remove('open');
	});

	contactPage.init();
	blogPage.init();
});
